
export default function AboutSection() {
  const skills = [
    {
      icon: 'ri-line-chart-line',
      title: 'Planejamento Estratégico',
      description: 'Desenvolvimento de estratégias para otimização de processos produtivos'
    },
    {
      icon: 'ri-dashboard-3-line',
      title: 'Indicadores e Metas',
      description: 'Implementação de KPIs e sistemas de monitoramento de performance'
    },
    {
      icon: 'ri-settings-3-line',
      title: 'Padronização',
      description: 'Criação e implementação de processos padronizados e POPs'
    },
    {
      icon: 'ri-shield-check-line',
      title: 'Integração Segurança × Produção',
      description: 'Harmonização entre produtividade e segurança do trabalho'
    }
  ];

  return (
    <section id="sobre" className="py-20 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid lg:grid-cols-2 gap-16 items-center">
          <div>
            <h2 className="text-4xl lg:text-5xl font-bold mb-8 text-gray-900">
              Sobre <span className="text-yellow-600">Mim</span>
            </h2>
            
            <div className="prose prose-lg text-gray-700 mb-8">
              <p className="text-xl leading-relaxed mb-6">
                Analista de PPCP JR na <strong>Companhia do Aço</strong>, aplicando 
                conhecimentos em engenharia civil para otimizar processos, prazos e qualidade.
              </p>
              
              <p className="text-lg leading-relaxed">
                Experiência sólida em controle de produção, gestão de obras e implementação 
                de melhorias contínuas, sempre focando na integração entre segurança e 
                produtividade.
              </p>
            </div>
            
            <div className="flex items-center gap-4 mb-8">
              <div className="w-16 h-16 bg-yellow-100 rounded-full flex items-center justify-center">
                <i className="ri-award-line text-2xl text-yellow-600"></i>
              </div>
              <div>
                <h3 className="font-semibold text-gray-900">Engenheira Civil</h3>
                <p className="text-gray-600">Especialista em PPCP e Segurança</p>
              </div>
            </div>
          </div>
          
          <div>
            <img 
              src="https://static.readdy.ai/image/38b84c1503cd17b8f12bcbc9adbcc594/11c40af043841ecfb285372d0bbeafb8.png"
              alt="Regiane Fialho - Engenheira Civil"
              className="w-full h-[600px] object-cover object-top rounded-2xl shadow-2xl"
            />
          </div>
        </div>
        
        <div className="mt-16 grid md:grid-cols-2 lg:grid-cols-4 gap-8">
          {skills.map((skill, index) => (
            <div key={index} className="bg-gray-50 rounded-xl p-6 hover:shadow-lg transition-shadow">
              <div className="w-12 h-12 bg-yellow-100 rounded-lg flex items-center justify-center mb-4">
                <i className={`${skill.icon} text-xl text-yellow-600`}></i>
              </div>
              <h3 className="font-semibold text-gray-900 mb-3">{skill.title}</h3>
              <p className="text-gray-600 text-sm leading-relaxed">{skill.description}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
